import { inject, Pipe, PipeTransform } from '@angular/core';
import { RmaSrcsetItem } from '@rma/generic/core/images';
import { ImageOptimiseService } from '../image-optimise-service/image-optimise.service';

@Pipe({
  name: 'rmaOptimiseImageSrcset',
  standalone: true,
})
export class ImageSrcsetOptimisePipe implements PipeTransform {
  private readonly imageOptimiseService = inject(ImageOptimiseService);

  public transform(value: string, config: RmaSrcsetItem[]): string {
    return this.imageOptimiseService.getSrcSetFromCdn(value, config);
  }
}
